import { render, staticRenderFns } from "./BtnConvert.vue?vue&type=template&id=56b49382&scoped=true&"
import script from "./BtnConvert.vue?vue&type=script&lang=js&"
export * from "./BtnConvert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b49382",
  null
  
)

export default component.exports